import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { appendTaskLogs, bulkCreateTasks, createTask, getTask, queryTasks, updateTask } from './generated/IndividualTaskClient/taskHttpRequests';
import { IndividualTaskClientBase } from './IndividualTaskClientBase';
export class IndividualTaskClient extends HttpBaseClient(IndividualTaskClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getTaskImpl", getTask);
    _defineProperty(this, "queryTasksImpl", queryTasks);
    _defineProperty(this, "createTaskImpl", createTask);
    _defineProperty(this, "bulkCreateTasksImpl", bulkCreateTasks);
    _defineProperty(this, "updateTaskImpl", updateTask);
    _defineProperty(this, "appendTaskLogsImpl", appendTaskLogs);
  }
}
//# sourceMappingURL=IndividualTaskClientHttp.js.map